// DeleteConfirmationModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from './CustomModal';
import ActionButton from './ActionButton';
import { useTranslation } from 'react-i18next';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ show, onConfirm, onCancel, record, isMobile }) => {
  const { t } = useTranslation();

  return (
    <CustomModal show={show} onClose={onCancel} title={t('deleteConfirmation.title')}>
      <div className="delete-confirmation">
        <p>
          {t('deleteConfirmation.message', {
            item: record?.fullName || `${record?.nombre} ${record?.apellido}` || t('deleteConfirmation.defaultUser'),
          })}
        </p>
        <div className="delete-confirmation-actions">
          <ActionButton
            onClick={onConfirm}
            label={t('deleteConfirmation.confirmButton')}
            icon="faCheck"
            isMobile={isMobile}
            colorType="primary"
            ariaLabel={t('deleteConfirmation.confirmButton')}
          />
          <ActionButton
            onClick={onCancel}
            label={t('deleteConfirmation.cancelButton')}
            icon="faTimes"
            isMobile={isMobile}
            colorType="secondary"
            ariaLabel={t('deleteConfirmation.cancelButton')}
          />
        </div>
      </div>
    </CustomModal>
  );
};

DeleteConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  record: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
};

DeleteConfirmationModal.defaultProps = {
  record: null,
};

export default DeleteConfirmationModal;
